import React from 'react';
import { Alert, Typography } from 'antd';
import {
  AzureOnboardingScopeRef,
  AzureScope,
} from '../../../../services/azure/azureOnboarding/azureOnboarding.model';
import { scopeName, scopeTypeLabel } from '../azureOnboarding.utils';

const { Text } = Typography;

interface ScopeRefListProps {
  refs: AzureOnboardingScopeRef[];
  scopes: AzureScope[];
  renderExtra?: (ref: AzureOnboardingScopeRef) => React.ReactNode;
}

export const ScopeRefList: React.FC<ScopeRefListProps> = ({ refs, scopes, renderExtra }) => (
  <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
    {refs.map((ref) => {
      const name = scopeName(ref, scopes);
      return (
        <li key={ref.id}>
          <Text type="secondary">{scopeTypeLabel(ref.scope_type)}</Text> {name}
          {name !== ref.scope_id && (
            <>
              {' '}
              <Text code>{ref.scope_id}</Text>
            </>
          )}
          {renderExtra && <> {renderExtra(ref)}</>}
        </li>
      );
    })}
  </ul>
);

export const CoveredButActiveAlert: React.FC<{
  refs?: AzureOnboardingScopeRef[];
  scopes: AzureScope[];
}> = ({ refs, scopes }) =>
  refs && refs.length > 0 ? (
    <Alert
      type="warning"
      showIcon
      style={{ marginTop: 16 }}
      message="Collected twice: these subscriptions are also billed under an active billing account. Switch one side off in Scopes."
      description={<ScopeRefList refs={refs} scopes={scopes} />}
    />
  ) : null;
